import React from 'react'
import { css } from '@emotion/react'
import Product from 'gatsby-theme-marketplace-base/src/components/Product/index'
import mediaQueries from '../../layout/media-queries'

const wrapperCss = css`
  margin: -16px auto 0 auto;

  ${mediaQueries.smallScreen(-280)} {
    margin: -30px auto 0 auto;
  }

  ${mediaQueries.mediumScreen()} {
    max-width: 100%;
  }
`

// This prevents the product logo from jumping when the page is scrolled
const spacerCss = css`
  margin-top: -1px;
  height: 1px;
  width: 1px;
`

export default (props) => (
  <>
    <div css={spacerCss} />
    <Product css={wrapperCss} {...props} />
  </>
)
